<template>
  <svg v-if="color_1"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#resources_group_icon)">
      <path
        d="M16.5 10.25L21 12.5L12 17L3 12.5L7.5 10.25M16.5 15.25L21 17.5L12 22L3 17.5L7.5 15.25M12 3L21 7.5L12 12L3 7.5L12 3Z"
        stroke="url(#resources_group_icon)"
        stroke-width="2" />
    </g>
    <defs>
      <linearGradient id="resources_group_icon"
                      x1="13"
                      y1="2.25"
                      x2="13"
                      y2="21.75"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <clipPath id="resources_group_icon">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg v-else
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 10.25L21 12.5L12 17L3 12.5L7.5 10.25M16.5 15.25L21 17.5L12 22L3 17.5L7.5 15.25M12 3L21 7.5L12 12L3 7.5L12 3Z"
      :stroke="color"
      stroke-width="2" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    },
    color_1: null,
    color_2: null
  }
}
</script>
